import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/HomeView'),
        meta: { title: '网站首页' }
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/about/about'),
        meta: { title: '关于我们' }
      },
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/product/product'),
        meta: { title: '产品中心' }
      },
      {
        path: 'product/details',
        name: 'ProductDetails',
        component: () => import('@/views/product/details'),
        meta: { title: '产品详情' }
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/news/news'),
        meta: { title: '新闻中心' }
      },
      {
        path: 'news/details',
        name: 'NewsDetails',
        component: () => import('@/views/news/details'),
        meta: { title: '新闻详情' }
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/contact/contact'),
        meta: { title: '联系我们' }
      },
      {
        path: 'after',
        name: 'after',
        component: () => import('@/views/after/after'),
        meta: { title: '售后中心' }
      },
      {
        path: 'information',
        name: 'information',
        component: () => import('@/views/information/information'),
        meta: { title: '资料下载' }
      }
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
